// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var V4 = require("uuid/v4");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelay__Showings__Showing = require("./PropertyWizardRelay__Showings__Showing.bs.js");
var PropertyWizardRelayShowings_draft_graphql = require("../../../__generated__/PropertyWizardRelayShowings_draft_graphql.bs.js");
var PropertyWizardRelayShowings_showing_graphql = require("../../../__generated__/PropertyWizardRelayShowings_showing_graphql.bs.js");

function PropertyWizardRelay__Showings$ScheduleShowing(props) {
  return JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: props.onClick,
              children: Caml_option.some(props.text)
            });
}

var ScheduleShowing = {
  make: PropertyWizardRelay__Showings$ScheduleShowing
};

var convertFragment = PropertyWizardRelayShowings_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayShowings_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowings_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, PropertyWizardRelayShowings_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayShowings_showing_graphql.node, convertFragment, fRef);
}

var ShowingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayShowings_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Showings(props) {
  var draft = use$1(props.draft);
  var showings = use(draft.draftProperty.showings.map(function (s) {
            return s.fragmentRefs;
          }));
  var updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  var addNewShowing = function (param) {
    updateDraftProperty(function (localDraftProperty) {
          var newrecord = Caml_obj.obj_dup(localDraftProperty);
          newrecord.showings = localDraftProperty.showings.concat([{
                  date: undefined,
                  endTime: undefined,
                  id: undefined,
                  key: V4(),
                  notes: undefined,
                  startTime: undefined,
                  type_: undefined
                }]);
          return newrecord;
        });
  };
  var _more = showings.length;
  return JsxRuntime.jsxs(FormV5.FormSection.make, {
              children: [
                showings.map(function (s, index) {
                      return JsxRuntime.jsx(View__Jsx3.make, {
                                  mt: "xl",
                                  children: Caml_option.some(JsxRuntime.jsx(PropertyWizardRelay__Showings__Showing.make, {
                                            showing: s.fragmentRefs,
                                            draft: draft.fragmentRefs,
                                            showingNum: index
                                          }))
                                }, s.key);
                    }),
                _more !== 0 ? JsxRuntime.jsx(View__Jsx3.make, {
                        mt: "md",
                        justifyContent: "flexEnd",
                        children: Caml_option.some(JsxRuntime.jsx(PropertyWizardRelay__Showings$ScheduleShowing, {
                                  onClick: addNewShowing,
                                  text: "Schedule another showing"
                                }))
                      }) : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "You haven't added any showings for this property.",
                                className: "pb-2"
                              }),
                          JsxRuntime.jsx(PropertyWizardRelay__Showings$ScheduleShowing, {
                                onClick: addNewShowing,
                                text: "Add a showing"
                              })
                        ],
                        className: "text-center py-4"
                      })
              ]
            });
}

var Components;

var FormSection;

var Validators;

var FormUtils;

var Form;

var Cell;

var Showing;

var make = PropertyWizardRelay__Showings;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Form = Form;
exports.Cell = Cell;
exports.Showing = Showing;
exports.ScheduleShowing = ScheduleShowing;
exports.ShowingsFragment = ShowingsFragment;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
